"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AsicAddressSchema = exports.ASIC_ADDRESS_CHARACTERS = exports.AUSTRALIAN_POSTCODE_REQUIRED_MESSAGE = exports.AUSTRALIAN_POSTCODE_LIMIT_MESSAGE = void 0;
const yup = __importStar(require("yup"));
exports.AUSTRALIAN_POSTCODE_LIMIT_MESSAGE = "Please enter exactly 4 digits";
exports.AUSTRALIAN_POSTCODE_REQUIRED_MESSAGE = "Please enter Post code";
// eslint-disable-next-line no-useless-escape
exports.ASIC_ADDRESS_CHARACTERS = /^[a-zA-Z!"#$%&'’(), *+-.\/:<=>?@ \d]+$/;
exports.AsicAddressSchema = {
    careOf: yup
        .string()
        .trim()
        .transform((value) => (value === "" ? undefined : value))
        .matches(exports.ASIC_ADDRESS_CHARACTERS)
        .max(50),
    line2: yup
        .string()
        .trim()
        .transform((value) => (value === "" ? undefined : value))
        .matches(exports.ASIC_ADDRESS_CHARACTERS)
        .max(50),
    street: yup
        .string()
        .trim()
        .transform((value) => (value === "" ? undefined : value))
        .required()
        .matches(exports.ASIC_ADDRESS_CHARACTERS)
        .max(52),
    locality: yup
        .string()
        .trim()
        .transform((value) => (value === "" ? undefined : value))
        .required()
        .matches(exports.ASIC_ADDRESS_CHARACTERS)
        .min(2)
        .max(30),
    state: yup
        .string()
        .trim()
        .transform((value) => (value === "" ? undefined : value))
        .required()
        .min(2)
        .when("country", ([country], schema) => country && (country.toLowerCase() === "australia" || country.toLowerCase() === "au")
        ? schema.matches(/^[A-Z]+$/).max(3)
        : schema.matches(exports.ASIC_ADDRESS_CHARACTERS).max(30)),
    postcode: yup
        .string()
        .trim()
        .transform((value) => (value === "" ? undefined : value))
        .required(exports.AUSTRALIAN_POSTCODE_REQUIRED_MESSAGE)
        .when("country", ([country], schema) => country && (country.toLowerCase() === "australia" || country.toLowerCase() === "au")
        ? schema.matches(/^\d+$/).min(4, exports.AUSTRALIAN_POSTCODE_LIMIT_MESSAGE).max(4, exports.AUSTRALIAN_POSTCODE_LIMIT_MESSAGE)
        : schema
            .matches(/^[a-zA-Z\d]+$/)
            .min(1)
            .max(10)),
    country: yup
        .string()
        .trim()
        .transform((value) => (value === "" ? undefined : value))
        .required()
        .matches(exports.ASIC_ADDRESS_CHARACTERS)
        .min(1)
        .max(30),
};
//# sourceMappingURL=AsicAddress.js.map